import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import SendIcon from '@material-ui/icons/Send';
import Nav from "../nav";
import { Browserrouter as Router, Switch, Route, Link } from 'react-router-dom';
import Privacy_Healthdata_policy from '../../pages/Privacy_Healthdata_policy';
import Terms_conditions from '../../pages/Terms_conditions';
import Our_expertise from '../NavLink/Our_expertise';
import FAQ from '../../pages/FAQ';
import About from '../../pages/About';
import LandingPage from '../../pages/landingpage';



const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    borderRadius: 18,
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    minHeight: 34,
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 12,
    paddingRight: 12,
    fontSize: 'clamp(0.72rem, 0.78vw, 0.9rem)',
    color: '#002D55',
    '&:focus': {
      backgroundColor: "#FFFFFF",
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: "#002D55",
      },
    },
    [theme.breakpoints.down('xs')]: {
      minHeight: 28,
      paddingTop: 4,
      paddingBottom: 4,
      paddingLeft: 10,
      paddingRight: 10,
    },
  },
}))(MenuItem);

const useStyles = makeStyles((theme) => ({
  menuButton: {
    backgroundColor: '#002D55',
    color: '#FFFFFF',
    marginRight: 0,
    maxHeight: 34,
    fontSize: 'clamp(0.72rem, 0.78vw, 0.9rem)',
    borderRadius: 18,
    textTransform: 'none',
    boxShadow: '0 10px 24px rgba(0, 45, 85, 0.18)',
    minWidth: 68,
    height: 30,
    padding: '4px 10px',
    [theme.breakpoints.up('lg')]: {
      minWidth: 62,
      height: 34,
      padding: '4px 18px',
    },
    [theme.breakpoints.up('xl')]: {
      minWidth: 62,
      height: 34,
      padding: '4px 20px',
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: 62,
      height: 28,
      padding: '3px 8px',
    },
  },
  menuIcon: {
    fontSize: 'clamp(0.95rem, 1vw, 1.15rem)',
  },
}));

export default function CustomizedMenus() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function handleClose2(nav) {
    window.location.replace(nav);
  };

    
  return (
    <div>
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        onClick={handleClick}
        className={classes.menuButton}
      >
        <MenuIcon className={classes.menuIcon} />
      </Button>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      > 
        <nav>
            <StyledMenuItem onClick={() => {handleClose2("/")}}>
              <ListItemText fontSize="small" primary="Home" style={{color: "#002D55"}}/>
            </StyledMenuItem>
            <StyledMenuItem onClick={() => {handleClose2("/Our_expertise")}} >
              <ListItemText fontSize="small" primary="Our expertise" style={{color: "#002D55"}}/>
            </StyledMenuItem>
            <StyledMenuItem onClick={() => {handleClose2("/FAQ")}}>
              <ListItemText fontSize="small" primary="FAQ" style={{color: "#002D55"}}/>
            </StyledMenuItem>
            <StyledMenuItem onClick={() => {handleClose2("/Privacy_Healthdata_policy")}}>
              <ListItemText fontSize="small" primary="Privacy & Healthdata policy" style={{color: "#002D55"}}/>
            </StyledMenuItem>
            <StyledMenuItem onClick={() => {handleClose2("/Terms_conditions")}}>
              <ListItemText fontSize="small" primary="Terms & Conditions" style={{color: "#002D55"}}/>
            </StyledMenuItem>
        </nav>
      </StyledMenu>
    </div>
  );
}
